import React, { useState } from "react";
import { Outlet, Link } from "react-router-dom";
import Sidebar from "./Sidbar";
import Footer from "./Footer";
import "../../../css/admin.css";
import Logo from '../../../image/download.png';
const BranchLayout = () => {
    const [toggle, setToggle] = useState(false);
    const toggleClass = () => {
        setToggle(!toggle);
    };
    // b_name is stored JSON-encoded, but tolerate a plain string so a bad
    // value can't take the whole layout down.
    const branchName = (() => {
        const raw = localStorage.getItem("b_name");
        try {
            return JSON.parse(raw);
        } catch {
            return raw || "";
        }
    })();
    return (
        <div className="dash-backdrop">
            <nav className="sb-topnav navbar navbar-expand navbar-light bg-light justify-content-between">
                <div className="d-flex align-items-start">
                    <Link className="navbar-brand ps-3" to="dashboard" title="CS Online School">
                        <img src={Logo} alt="CS Education" title="CS Education" />
                    </Link>
                    <div className="side-bar-btn" onClick={() => toggleClass()}>
                        <i className="fa-solid fa-bars"></i>
                    </div>
                </div>
                <ul className="navbar-nav ms-auto ms-md-0 me-3 me-lg-4 align-items-center">
                    <li className="nav-item">
                        <span style={{ fontSize: '15px', fontWeight: 600, color: '#1f2937', marginRight: '14px' }}>
                            {branchName}
                        </span>
                    </li>
                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" id="navbarDropdown" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"><i className="fas fa-user fa-fw"></i></a>
                        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                            <li><Link className="dropdown-item" to="/branch/my-account"><i className="fa-solid fa-user-gear"></i> My Account</Link></li>
                            <li><Link className="dropdown-item" to="/branch/settings/payment"><i className="fa-solid fa-credit-card"></i> Online Payment</Link></li>
                            <li><Link to="/logout" className="dropdown-item"><i className="fa-solid fa-arrow-right-from-bracket"></i> Logout</Link></li>
                        </ul>
                    </li>
                </ul>
            </nav>
            <div id="layoutSidenav" className={toggle ? `toggle-full-width` : ''}>
                <Sidebar />
                <div id="layoutSidenav_content">
                    <Outlet />
                    <Footer />
                </div>
            </div>
        </div>
    )
};
export default BranchLayout;